module.exports = __webpack_public_path__ + "img/message.d99033db.svg";